import React from 'react';
import { bool, func, number, string } from 'prop-types';
import GeoDifferentialAdjustment from '../Geo/GeoDifferentialAdjustment';
import SkillDifferentialAdjustment from '../Skill/SkillDifferentialAdjustment';
import './CardFooter.scss';

class CardFooter extends React.Component {
  static propTypes = {
    count: number,
    id: string,
    isAdded: bool,
    isExpanded: bool,
    jobFamily: string,
    location: string,
    totalAdjustment: number,
    totalAdjustmentOverride: number,
    toggleExpand: func,
    updateTotalAdjustmentOverride: func,
    differentialLoading: bool,
    differentialFailed: bool
  };

  renderGeoFooter = () => {
    const { jobFamily, location, totalAdjustment, totalAdjustmentOverride, updateTotalAdjustmentOverride } = this.props;
    return (
      <GeoDifferentialAdjustment
        jobFamily={jobFamily}
        location={location}
        totalAdjustment={totalAdjustment}
        totalAdjustmentOverride={totalAdjustmentOverride}
        updateTotalAdjustmentOverride={updateTotalAdjustmentOverride}
      />
    );
  };

  renderSkillFooter = () => {
    const { count, totalAdjustment, totalAdjustmentOverride, updateTotalAdjustmentOverride } = this.props;

    return (
      <SkillDifferentialAdjustment
        count={count}
        totalAdjustment={totalAdjustment}
        totalAdjustmentOverride={totalAdjustmentOverride}
        updateTotalAdjustmentOverride={updateTotalAdjustmentOverride}
      />
    );
  };

  render() {
    const { id, toggleExpand, isAdded, isExpanded, differentialLoading, differentialFailed } = this.props;

    return (
      <div className="card__footer">
        {!isAdded && !(differentialLoading || differentialFailed) && (
          <React.Fragment>
            {id === 'skill' && this.renderSkillFooter()}
            {id === 'geo' && this.renderGeoFooter()}
          </React.Fragment>
        )}
        {differentialLoading && (
          <div className="pxl-text-muted">
            <i className="icon-animate-spin icon-spin"></i> Retrieving geo differential data...
          </div>
        )}
        {differentialFailed && (
          <div className="geo-differential__loading-section">
            <i className="icon-warning"></i> The data couldn't be retrieved. Reload the page or check your connection.
          </div>
        )}
        <i
          className={isExpanded ? 'icon-up-open' : 'icon-down-open'}
          onClick={() => {
            toggleExpand();
          }}
        />
      </div>
    );
  }
}

export default CardFooter;
